import { render, staticRenderFns } from "./PagePP.vue?vue&type=template&id=13bf7284&"
import script from "./PagePP.vue?vue&type=script&lang=js&"
export * from "./PagePP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports